import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Importa o CSS do Bootstrap
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar } from 'recharts';
import { CheckCircle, AlertCircle, TrendingDown, Award, DollarSign, Users, Clock, Shield } from 'lucide-react';

// O import './index.css'; foi removido

const PropostasComparativo = () => {
    const [tabAtiva, setTabAtiva] = useState('resumo');

    const dadosCusto = [
        { nome: 'Reis Office', valor: 1049580, cor: '#10b981' },
        { nome: 'Office Total', valor: 1360623, cor: '#3b82f6' },
        { nome: 'Compactprint', valor: 1706000, cor: '#ef4444' },
        { nome: 'W3K', valor: 1427520, cor: '#f59e0b' },
        { nome: 'Access', valor: 1900000, cor: '#8b5cf6' },
        { nome: 'iD Docs', valor: 2350000, cor: '#ec4899' },
    ];

    // ... (o restante dos seus dados permanece o mesmo) ...
    const dadosCustoMensal = [
        { nome: 'Reis Office', valor: 17493 },
        { nome: 'Office Total', valor: 19444 },
        { nome: 'W3K', valor: 23792 },
        { nome: 'Compactprint', valor: 28200 },
    ];

    const dadosPorPagina = [
        { nome: 'Access', valor: 0.38 },
        { nome: 'iD Docs', valor: 0.47 },
        { nome: 'Reis Office', valor: 0.497 },
        { nome: 'Office Total', valor: 0.57 },
        { nome: 'W3K', valor: 0.59 },
    ];

    const avaliacaoTecnica = [
        { criterio: 'Software', reisOffice: 4, officeTotal: 5, w3k: 4 },
        { criterio: 'Equipe', reisOffice: 4, officeTotal: 5, w3k: 3 },
        { criterio: 'Suporte', reisOffice: 5, officeTotal: 5, w3k: 4 },
        { criterio: 'Conformidade', reisOffice: 5, officeTotal: 5, w3k: 3 },
        { criterio: 'Preço', reisOffice: 5, officeTotal: 4, w3k: 3 },
    ];

    const fornecedores = [
        {
            nome: 'Reis Office',
            ranking: 1,
            investimento: 'R$ 1.049.580',
            mensal: 'R$ 17.493',
            prazo: '60 meses',
            equipe: '2 profissionais CLT',
            capacidade: '35.200 pág/mês',
            software: 'Therefore Online',
            usuarios: '17 usuários',
            armazenamento: '500 GB',
            pontosFortesResumo: ['Menor custo total', 'Escopo fechado', 'Decreto 10.278/2020', 'Previsibilidade'],
            pontosFracosResumo: ['Contrato 60 meses', 'Cliente fornece certificado'],
            notaGeral: 9.2,
            cor: '#10b981'
        },
        {
            nome: 'Office Total',
            ranking: 2,
            investimento: 'R$ 1.360.623',
            mensal: 'R$ 19.444',
            prazo: '36 meses',
            equipe: '3 profissionais',
            capacidade: 'Não especificado',
            software: 'M-Files',
            usuarios: 'Ilimitados',
            armazenamento: '100 GB',
            pontosFortesResumo: ['Melhor software', 'Metodologia consultiva', 'Integração Gupy'],
            pontosFracosResumo: ['Custo maior', 'Armazenamento caro'],
            notaGeral: 8.7,
            cor: '#3b82f6'
        },
        {
            nome: 'Access',
            ranking: 3,
            investimento: 'R$ 1.900.000',
            mensal: 'Variável',
            prazo: '8 meses',
            equipe: 'Não especificado',
            capacidade: 'Variável',
            software: 'All Store',
            usuarios: 'Ilimitados',
            armazenamento: 'Variável',
            pontosFortesResumo: ['Menor R$/página', 'Certificação incluída', 'Prazo curto'],
            pontosFracosResumo: ['Proposta pouco detalhada', 'Estimativa duvidosa'],
            notaGeral: 7.5,
            cor: '#8b5cf6'
        },
        // ... (resto dos fornecedores) ...
    ];


    return (
        <div className="min-vh-100 bg-light text-dark p-4 p-md-5">
            <div className="container-xl">
                <div className="bg-primary bg-gradient rounded-4 shadow-lg p-4 p-md-5 mb-5 text-white">
                    <h1 className="h1 mb-3">Análise Comparativa - Digitalização de Documentos</h1>
                    <p className="fs-4 text-white-50">Santa Mônica - Rede de Ensino</p>
                    <div className="mt-4 d-flex flex-wrap gap-4 small">
                        <div className="d-flex align-items-center gap-2">
                            <Users size={20} />
                            <span>6 Fornecedores Analisados</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                            <Shield size={20} />
                            <span>Volume Estimado: 2-5M páginas</span>
                        </div>
                    </div>
                </div>

                <ul className="nav nav-pills nav-fill mb-5 p-2 bg-white rounded-3 shadow-sm flex-wrap gap-2">
                    {['resumo', 'custos', 'fornecedores', 'tecnico', 'recomendacao'].map((tab) => (
                        <li className="nav-item flex-grow-1" style={{ minWidth: '140px' }} key={tab}>
                            <button
                                onClick={() => setTabAtiva(tab)}
                                className={`nav-link w-100 py-3 px-4 rounded-3 fw-semibold ${tabAtiva === tab ? 'active' : 'text-dark'}`}
                            >
                                {tab === 'resumo' && 'Resumo'}
                                {tab === 'custos' && 'Custos'}
                                {tab === 'fornecedores' && 'Fornecedores'}
                                {tab === 'tecnico' && 'Técnico'}
                                {tab === 'recomendacao' && 'Recomendação'}
                            </button>
                        </li>
                    ))}
                </ul>

                {tabAtiva === 'resumo' && (
                    <div>
                        <div className="row g-4 mb-4">
                            <div className="col-md-4">
                                <div className="bg-success bg-gradient rounded-3 shadow-lg p-4 text-white">
                                    <div className="d-flex align-items-center gap-3 mb-2">
                                        <TrendingDown size={32} />
                                        <span className="small fw-medium opacity-75">Menor Investimento</span>
                                    </div>
                                    <p className="h2 fw-bold mb-1">R$ 1.049.580</p>
                                    <p className="small opacity-75">Reis Office - 60 meses</p>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="bg-primary bg-gradient rounded-3 shadow-lg p-4 text-white">
                                    <div className="d-flex align-items-center gap-3 mb-2">
                                        <Award size={32} />
                                        <span className="small fw-medium opacity-75">Melhor Tecnologia</span>
                                    </div>
                                    <p className="h2 fw-bold mb-1">M-Files</p>
                                    <p className="small opacity-75">Office Total</p>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="bg-info bg-gradient rounded-3 shadow-lg p-4 text-white">
                                    <div className="d-flex align-items-center gap-3 mb-2">
                                        <DollarSign size={32} />
                                        <span className="small fw-medium opacity-75">Menor Custo/Página</span>
                                    </div>
                                    <p className="h2 fw-bold mb-1">R$ 0,38</p>
                                    <p className="small opacity-75">Access</p>
                                </div>
                            </div>
                        </div>

                        <div className="card shadow-lg p-4 border-0 mb-4">
                            <h2 className="card-title h4 fw-bold text-dark mb-4">Distribuição de Investimentos (60 meses)</h2>
                            <ResponsiveContainer width="100%" height={400}>
                                <PieChart>
                                    <Pie
                                        data={dadosCusto}
                                        cx="50%"
                                        cy="50%"
                                        labelLine={false}
                                        label={({ nome, percent }) => `${nome}: ${(percent * 100).toFixed(0)}%`}
                                        outerRadius={130}
                                        fill="#8884d8"
                                        dataKey="valor"
                                    >
                                        {dadosCusto.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.cor} />
                                        ))}
                                    </Pie>
                                    <Tooltip formatter={(value) => `R$ ${value.toLocaleString('pt-BR')}`} />
                                </PieChart>
                            </ResponsiveContainer>
                        </div>

                        <div className="card shadow-lg p-4 border-0 mb-4">
                            <h2 className="card-title h4 fw-bold text-dark mb-4">Top 3 Recomendações</h2>
                            <div>
                                {fornecedores.slice(0, 3).map((f) => (
                                    <div key={f.nome} className="d-flex align-items-center gap-4 p-3 bg-light rounded-3 mb-3">
                                        <span className="h2 fw-bold" style={{ color: f.cor }}>#{f.ranking}</span>
                                        <div className="flex-grow-1">
                                            <h3 className="fw-bold h5 text-dark">{f.nome}</h3>
                                            <p className="small text-muted">{f.investimento} - Nota: {f.notaGeral}/10</p>
                                        </div>
                                        <div className="text-end">
                                            <p className="small text-muted">Mensal</p>
                                            <p className="fw-bold text-dark">{f.mensal}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {tabAtiva === 'custos' && (
                    <div>
                        <div className="card shadow-lg p-4 border-0 mb-4">
                            <h2 className="card-title h4 fw-bold text-dark mb-4">Investimento Total (60 meses)</h2>
                            <ResponsiveContainer width="100%" height={400}>
                                <BarChart data={dadosCusto} layout="vertical">
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis type="number" tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`} />
                                    <YAxis dataKey="nome" type="category" width={120} />
                                    <Tooltip formatter={(value) => `R$ ${value.toLocaleString('pt-BR')}`} />
                                    <Bar dataKey="valor" radius={[0, 8, 8, 0]}>
                                        {dadosCusto.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.cor} />
                                        ))}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </div>

                        <div className="card shadow-lg p-4 border-0 mb-4">
                            <h2 className="card-title h4 fw-bold text-dark mb-4">Custo Mensal</h2>
                            <ResponsiveContainer width="100%" height={350}>
                                <BarChart data={dadosCustoMensal}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="nome" />
                                    <YAxis tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`} />
                                    <Tooltip formatter={(value) => `R$ ${value.toLocaleString('pt-BR')}`} />
                                    <Bar dataKey="valor" fill="#3b82f6" radius={[8, 8, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>

                        <div className="card shadow-lg p-4 border-0 mb-4">
                            <h2 className="card-title h4 fw-bold text-dark mb-4">Custo por Página</h2>
                            <ResponsiveContainer width="100%" height={350}>
                                <BarChart data={dadosPorPagina}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="nome" />
                                    <YAxis tickFormatter={(value) => `R$ ${value.toFixed(2)}`} />
                                    <Tooltip formatter={(value) => `R$ ${value.toFixed(2)}`} />
                                    <Bar dataKey="valor" fill="#10b981" radius={[8, 8, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )}

                {tabAtiva === 'fornecedores' && (
                    <div>
                        {fornecedores.map((f) => (
                            <div key={f.nome} className="card shadow-lg p-4 mb-4 border-start border-4" style={{ borderColor: f.cor }}>
                                <div className="d-flex align-items-start gap-4 mb-4">
                                    <span className="h2 fw-bold" style={{ color: f.cor }}>#{f.ranking}</span>
                                    <div className="flex-grow-1">
                                        <h3 className="h3 fw-bold text-dark">{f.nome}</h3>
                                        <div className="d-flex align-items-center gap-2 mt-1">
                                            <Award className="text-warning" size={20} />
                                            <span className="fs-5 fw-semibold text-body-secondary">Nota: {f.notaGeral}/10</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="row g-4 mb-4">
                                    <div className="col-6">
                                        <div className="bg-success-subtle p-4 rounded-3">
                                            <p className="small text-body-secondary mb-1">Investimento Total</p>
                                            <p className="fs-4 fw-bold text-success-emphasis">{f.investimento}</p>
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="bg-primary-subtle p-4 rounded-3">
                                            <p className="small text-body-secondary mb-1">Mensal</p>
                                            <p className="fs-4 fw-bold text-primary-emphasis">{f.mensal}</p>
                                        </div>
                                    </div>
                                </div>

                                <div className="row g-3 mb-4 small">
                                    <div className="col-6"><span className="text-muted">Prazo:</span> <span className="fw-semibold">{f.prazo}</span></div>
                                    <div className="col-6"><span className="text-muted">Equipe:</span> <span className="fw-semibold">{f.equipe}</span></div>
                                    <div className="col-6"><span className="text-muted">Software:</span> <span className="fw-semibold">{f.software}</span></div>
                                    <div className="col-6"><span className="text-muted">Capacidade:</span> <span className="fw-semibold">{f.capacidade}</span></div>
                                </div>

                                <div className="row g-4">
                                    <div className="col-12 col-md-6">
                                        <p className="small fw-semibold text-success-emphasis mb-2 d-flex align-items-center gap-1">
                                            <CheckCircle size={16} /> Pontos Fortes
                                        </p>
                                        <ul className="list-unstyled small text-body-secondary">
                                            {f.pontosFortesResumo.map((p, i) => (
                                                <li key={i} className="mb-1">• {p}</li>
                                            ))}
                                        </ul>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <p className="small fw-semibold text-danger-emphasis mb-2 d-flex align-items-center gap-1">
                                            <AlertCircle size={16} /> Atenção
                                        </p>
                                        <ul className="list-unstyled small text-body-secondary">
                                            {f.pontosFracosResumo.map((p, i) => (
                                                <li key={i} className="mb-1">• {p}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {tabAtiva === 'tecnico' && (
                    <div>
                        <div className="card shadow-lg p-4 border-0 mb-4">
                            <h2 className="card-title h4 fw-bold text-dark mb-4">Avaliação Técnica</h2>
                            <ResponsiveContainer width="100%" height={500}>
                                <RadarChart data={avaliacaoTecnica}>
                                    <PolarGrid />
                                    <PolarAngleAxis dataKey="criterio" />
                                    <PolarRadiusAxis angle={90} domain={[0, 5]} />
                                    <Radar name="Reis Office" dataKey="reisOffice" stroke="#10b981" fill="#10b981" fillOpacity={0.6} />
                                    <Radar name="Office Total" dataKey="officeTotal" stroke="#3b82f6" fill="#3b82f6" fillOpacity={0.6} />
                                    <Radar name="W3K" dataKey="w3k" stroke="#f59e0b" fill="#f59e0b" fillOpacity={0.6} />
                                </RadarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                )}

                {tabAtiva === 'recomendacao' && (
                    <div>
                        <div className="bg-success bg-gradient rounded-4 shadow-lg p-5 text-white mb-4">
                            <div className="d-flex align-items-center gap-4">
                                <Award size={64} />
                                <div>
                                    <h2 className="h2 fw-bold">Recomendação Final</h2>
                                    <p className="text-white-50 fs-5">Análise consolidada</p>
                                </div>
                            </div>
                        </div>

                        <div className="row g-4 mb-4">
                            {fornecedores.slice(0, 3).map((f) => (
                                <div key={f.nome} className="col-md-4">
                                    <div className="card shadow-lg p-4 border-0 border-top border-4 h-100" style={{ borderColor: f.cor }}>
                                        <div className="text-center mb-4">
                                            <div
                                                className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                                style={{ width: '4rem', height: '4rem', backgroundColor: `${f.cor}20` }}
                                            >
                                                <span className="h2 fw-bold" style={{ color: f.cor }}>{f.ranking}</span>
                                            </div>
                                            <h3 className="h3 fw-bold text-dark">{f.nome}</h3>
                                            <p className="small fw-semibold mt-1" style={{ color: f.cor }}>
                                                {f.ranking === 1 && 'MELHOR CUSTO-BENEFÍCIO'}
                                                {f.ranking === 2 && 'MELHOR TECNOLOGIA'}
                                                {f.ranking === 3 && 'MENOR R$/PÁGINA'}
                                            </p>
                                        </div>

                                        <div className="mb-4">
                                            <div className="p-3 rounded-3 mb-3" style={{ backgroundColor: `${f.cor}10` }}>
                                                <p className="small text-muted mb-1">Investimento Total</p>
                                                <p className="fs-4 fw-bold" style={{ color: f.cor }}>{f.investimento}</p>
                                            </div>
                                        </div>

                                        <div className="border-top pt-4 mt-auto">
                                            <p className="fw-semibold text-dark mb-2 small">Por que escolher:</p>
                                            <ul className="list-unstyled small text-muted">
                                                {f.pontosFortesResumo.map((p, i) => (
                                                    <li key={i} className="mb-1">✓ {p}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="card shadow-lg p-4 border-0">
                            <h3 className="h4 fw-bold text-dark mb-4">Conclusão Executiva</h3>
                            <p className="text-body-secondary mb-4">
                                Para um projeto de digitalização de 2-5 milhões de páginas ao longo de 60 meses,
                                a <strong className="text-success">Reis Office</strong> apresenta o melhor equilíbrio
                                entre custo, escopo e segurança jurídica.
                            </p>
                            <p className="text-muted">
                                Se a prioridade for tecnologia de ponta, a <strong className="text-primary">Office Total</strong> é
                                a escolha recomendada, com o software M-Files líder mundial.

                            </p>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PropostasComparativo;